/* A key the trainer can press, drawn as a keycap beside the words that name what it does. The ink
 * is the text around it; a surface that wants the cap quieter sets `color` with a class of its own. */

.kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--sz-kbd);
  height: var(--sz-kbd);
  padding: var(--space-0) var(--space-5px);
  font-family: inherit;
  font-size: var(--fs-caption);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-none);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-5px);
}
